<template>
  <div ref="Drawer">
    <a-drawer
      v-model:open="open"
      class="custom-class"
      root-class-name="root-class-name"
      :closable="false"
      placement="right"
      :width="'628px'"
      @after-open-change="afterOpenChange"
      @close="cancel"
      wrapClassName="drawer-style"
      :getContainer="() => Drawer"
    >
      <template v-slot:title>
        <div>
          <img
            :src="require('@/assets/icons/qy_icon.png')"
            style="width: 25px; vertical-align: top"
            alt=""
          />

          <span class="ml10 first_title">企业管理/</span
          ><span>{{ drawerTitle }}</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>
      <template v-if="drawerTitle === '新增' || drawerTitle === '编辑'" #footer>
        <div class="botm">
          <a-button type="primary" ghost class="ml10" @click="cancel"
            >取消</a-button
          >
          <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
        </div>
      </template>
      <template v-else-if="drawerTitle === '审核'" #footer>
        <div class="botm">
          <a-button type="primary" ghost class="ml10" @click="cancel"
          >取消</a-button
          >
          <a-button type="primary" class="ml10" @click="confirmReview">确定</a-button>
        </div>
      </template>
      <a-form
        ref="formRef"
        :model="form"
        name="basic"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-item label="公司名称" name="name">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.name"
            placeholder="请输入"
          />
          <div v-else>{{ form.name }}</div>
        </a-form-item>
        <a-form-item label="统一信用代码">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.unifyCode"
            placeholder="请输入"
          />
          <div v-else>{{ form.unifyCode }}</div>
        </a-form-item>
        <a-form-item label="法人姓名">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.corporationName"
            placeholder="请输入"
          />
          <div v-else>{{ form.corporationName }}</div>
        </a-form-item>
        <a-form-item label="联系人姓名" name="linkName">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.linkName"
            placeholder="请输入"
          />
          <div v-else>{{ form.linkName }}</div>
        </a-form-item>
        <a-form-item label="联系人电话" name="linkPhone">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.linkPhone"
            placeholder="请输入"
          />
          <div v-else>{{ form.linkPhone }}</div>
        </a-form-item>
        <a-form-item label="联系邮箱">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.email"
            placeholder="请输入"
          />
          <div v-else>{{ form.email }}</div>
        </a-form-item>
        <a-form-item label="申请主体类型">
          <a-radio-group
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.category"
          >
            <a-radio
              v-for="(item, index) in typeList"
              :key="item.id"
              :value="item.dataCode + ''"
              @change="radioChange"
            >
              {{ item.dataValue }}
              <div v-if="item.dataValue === '其它科技型企业' && flag">
                <input
                  :disabled="drawerTitle === '详情' || drawerTitle === '审核'"
                  class="old_inp"
                  type="text"
                  v-model="userInput"
                />
              </div>
            </a-radio>
          </a-radio-group>
          <div v-else>
            {{
              getSingleTypeValue(
                appStore.SysDictVOList,
                dataType + "category" + form.category
              )
            }}
            <span v-if="userInput"> :&nbsp;&nbsp;</span>
            {{ userInput }}
          </div>
        </a-form-item>
        <a-form-item label="资质附件" name="licenseAttachmentArr" tooltip="企业需上传公司营业职照，高校/研究所需上传单位证明">
          <images-uploader
              v-model:image-urls="form.licenseAttachmentArr"
              :path-name="'license'"
              :max-count="5"
              :box-width="180"
              :box-height="120"
              :only-preview="drawerTitle === '详情' || drawerTitle === '审核'"
              @upload-success="handleUploadSuccess"
              @delete="handleDelete"
          />
        </a-form-item>
        <a-form-item label="公司地址">
          <a-input
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            v-model:value="form.address"
            placeholder="请输入"
          />
          <div v-else>{{ form.address }}</div>
        </a-form-item>
        <a-form-item v-if="drawerTitle === '新增'" label="密码" name="passwd">
          <password-input
              @focus="inputPassFocus"
              v-if="drawerTitle === '新增'"
              v-model:value="form.passwd"
              placeholder="请输入密码"
          />
          <div v-else>{{ form.passwd }}</div>
        </a-form-item>
        <a-form-item
            v-if="drawerTitle === '新增'"
            label="确认密码"
            name="repassword"
        >
          <password-input
              @focus="inputRepassFocus"
              v-if="drawerTitle === '新增'"
              v-model:value="form.repassword"
              placeholder="请重新输入密码"
          />
          <div v-else>{{ form.repassword }}</div>
        </a-form-item>
<!--        <a-form-item v-if="drawerTitle === '新增' || drawerTitle === '编辑'" label="密码" name="passwd">-->
<!--          <a-input-password-->
<!--            @focus="inputPassFocus"-->
<!--            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"-->
<!--            :visibility-toggle="drawerTitle === '编辑' ? false : true"-->
<!--            v-model:value="form.passwd"-->
<!--            placeholder="请输入"-->
<!--          />-->
<!--          <div v-else>{{ form.passwd }}</div>-->
<!--        </a-form-item>-->
<!--        <a-form-item-->
<!--          v-if="drawerTitle === '新增' || drawerTitle === '编辑'"-->
<!--          label="确认密码"-->
<!--          name="repassword"-->
<!--        >-->
<!--          <a-input-password-->
<!--          @focus="inputRepassFocus"-->
<!--            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"-->
<!--            :visibility-toggle="drawerTitle === '编辑' ? false : true"-->
<!--            v-model:value="form.repassword"-->
<!--            placeholder="请输入"-->
<!--          />-->
<!--          <div v-else>{{ form.repassword }}</div>-->
<!--        </a-form-item>-->
        <a-form-item label="状态">
          <a-switch
            v-if="drawerTitle === '新增' || drawerTitle === '编辑'"
            checked-children="启用"
            un-checked-children="禁用"
            v-model:checked="status"
            @change="switchChange"
          />
          <div v-else>{{ status === true ? "启用" : "禁用" }}</div>
        </a-form-item>
      </a-form>

      <a-form
          v-if="drawerTitle === '审核'"
          ref="reviewFormRef"
          :model="reviewform"
          name="basic"
          :rules="rules"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
      >
        <a-form-item label="审核意见" name="checkResult">
          <a-radio-group v-model:value="reviewform.checkResult">
            <a-radio :value="1">通过</a-radio>
            <a-radio :value="0">不通过</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model:value="reviewform.causeMsg" placeholder="审核不通过时为必填" :rows="4" />
        </a-form-item>
      </a-form>

    </a-drawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineExpose,
  toRaw,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { cloneDeep } from "lodash-es";
import { message } from "ant-design-vue";
import { detailById, checkPhoneNumRepeat } from "@/api/enterprise/index.js";
import { getSingleTypeValue } from "@/utils/matchDic";
import useAppStore from "@/store/modules/app";
import imagesUploader from '@/components/imagesUploader/index.vue';
import PasswordInput from '@/components/PasswordInput';
const appStore = useAppStore();

const dataType = "companyType";
const dataCode = "category";

const Drawer = ref();
const props = defineProps({
  drawerTitle: {
    type: String,
    default: () => "",
  },
});
const checkAge = async (_rule, value) => {
  if (!value) {
    return Promise.reject("请输入电话号码");
  } else {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的电话号码");
    } else {
      return Promise.resolve();
    }
  }
};
const checkCardNo = async (_rule, value) => {
  if (value) {
    const reg =
      /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
    if (!reg.test(value)) {
      return Promise.reject("请输入正确的身份证号码");
    } else {
      return Promise.resolve();
    }
  }
};

const checkRePsw = async (_rule, value) => {
  console.log(_rule, form.value);
  if (!value) {
    return Promise.reject("请再次输入密码");
  } else {
    if (form.value.passwd != value) {
      return Promise.reject("密码不一致，请检查");
    } else {
      return Promise.resolve();
    }
  }
};

let typeList = ref([]); // 单选框选择

watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      typeList.value = val[index].children;
      console.log(typeList.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const status = ref(true);
const userInput = ref("");

const editId = ref(null);

const open = ref(false);
const formRef = ref();
const form = ref({
  name: "",
  linkPhone: "",
  linkName: "",
  unifyCode: "",
  corporationName: "",
  address: "",
  passwd: "",
  repassword: "",
  status: 1,
  email: "",
  category: "int",
  licenseAttachmentArr: []
});

const reviewFormRef = ref();
const reviewform = ref({
  checkResult: "",
  causeMsg: ""
});

const reset = () => {
  form.value = {
    name: "",
    linkPhone: "",
    linkName: "",
    unifyCode: "",
    corporationName: "",
    address: "",
    passwd: "",
    repassword: "",
    status: 1,
    email: "",
    category: "int",
    licenseAttachmentArr: []
  };
  status.value = true;
  flag.value = false;
  userInput.value = "";
};
const cardType = ref(1);

const rules = {
  name: [{ required: true, message: "公司名称不能为空", trigger: "change" }],
  linkName: [
    { required: true, message: "联系人姓名不能为空", trigger: "change" },
  ],
  linkPhone: [
    {
      required: true,
      trigger: "blur",
      validator: checkAge,
    },
  ],
  passwd: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, max: 66, message: "长度在 6 个字符以上", trigger: "blur" },
  ],
  repassword: [{ required: true, trigger: "blur", validator: checkRePsw }],
};

const flag = ref(false);

const radioChange = (e) => {
  console.log(e.target.value);
  if (e.target.value === "other") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};

const afterOpenChange = (bool) => {
  console.log("open", bool);
};
const showDrawer = (data) => {
  open.value = true;
  reset();
  if (data) {
    console.log(data);
    editId.value = data.id;
    detailById(data.id).then((res) => {
      console.log(res);
      if (res.code === 200) {
        let type;
        switch (res.data.status) {
          case 1:
            type = true;
            break;
          case 0:
            type = false;
            break;
          default:
            type = null;
        }
        status.value = type;
        form.value = res.data;
        form.value.repassword = res.data.passwd;
        if (
          res.data.category.indexOf("other_") != -1 ||
          res.data.category.indexOf("other") != -1
        ) {
          flag.value = true;
          let arr = res.data.category.split("_");
          console.log(arr);
          form.value.category = arr[0];
          userInput.value = arr[1];
        }
      }
    });
  }
};
const closeOpen = () => {
  open.value = false;
  formRef.value.resetFields();
};

const switchChange = (record) => {
  console.log(record);
  let status;
  switch (record) {
    case true:
      status = 1;
      break;
    case false:
      status = 0;
      break;
    default:
      status = null;
  }
  form.value.status = status;
};

const inputPassFocus = (e) => {
  console.log(e.target.value);
  if (props.drawerTitle === "编辑") {
    form.value.passwd = "";
  }
};

const inputRepassFocus = (e)=>{
    console.log(e.target.value);
  if (props.drawerTitle === "编辑") {
    form.value.repassword = "";
  }
}

const emit = defineEmits(["drawerEvent"]);

// 保存
const confirm = () => {
  console.log("保存");
  formRef.value
    .validate()
    .then(() => {
      console.log("values", form.value);
      const drawerValue = JSON.parse(JSON.stringify(form.value));
      if (drawerValue.category === "other" && userInput.value !== "") {
        drawerValue.category = drawerValue.category + "_" + userInput.value;
      }
      checkPhoneNumRepeat(editId.value, drawerValue.linkPhone).then((res) => {
        console.log(res);
        if (res.data) {
          message.error("手机号重复，请重新填写");
        } else {
          emit("drawerEvent", drawerValue);
          open.value = false;
        }
      });
    })
    .catch((error) => {
      console.log("error", error);
    });
};

//审核
const confirmReview = () => {

  console.log("reviewform.value", reviewform.value)
  const drawerValue = JSON.parse(JSON.stringify(reviewform.value));
  drawerValue.id = editId.value;
  emit("drawerEvent", drawerValue);
  open.value = false;
}

const handleUploadSuccess = (url, urls) => {
  console.log('上传成功', url);
  console.log('当前所有图片', urls);
};

const handleDelete = (index) => {
  console.log('删除图片索引', index);
};

// 取消
const cancel = () => {
  console.log("取消");
  open.value = false;
  formRef.value.resetFields();
};

// 使用 defineExpose 向外暴露指定的数据和方法
defineExpose({
  showDrawer,
});
</script>
<style lang="less" scoped>
.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.botm {
  text-align: center;
}

.inp {
  width: 470px;
}

.col {
  display: flex;
  justify-content: right;
  align-items: center;
}

.add_text {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #186ff2;
}

/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f2f4f7;
}

.left {
  text-align: left;
  align-items: flex-start;

  .ant-radio-group {
    width: 81%;
  }
}

/deep/ .ant-drawer .ant-drawer-footer {
  display: flex;
  justify-content: center;
  border-top: 0px;
  margin-bottom: 40px;
}

/deep/ .ant-drawer .ant-drawer-header {
  border-bottom: 0px;
}

.botm {
  display: flex;
  justify-content: space-between;
  width: 32%;
}

/deep/.ant-drawer-title {
  color: rgba(29, 33, 41, 1);
  font-weight: 600;
  font-size: 18px;
}

/deep/.ant-radio-group {
  margin-top: 6px;
}

/deep/.ant-radio-wrapper {
  width: 139px;
}

.old_inp {
  /* 移除原生边框 */
  border: none;
  /* 添加新边框*/
  border-bottom: 1px solid #000;
  /* 左侧内边距 */
  // padding-left: 10px;
  /* 输入框宽度 */
  width: 100px;
  /* 移除点击输入框时浏览器提供的默认轮廓 */
  outline: none;
  position: absolute;
  bottom: 3px;
  left: 130px;
}

/deep/.ant-radio-wrapper:last-child {
  width: 200px;
  position: relative;
  margin-top: 5px;
}
</style>
